import PhonePreview from '@/src/components/molecule/PhonePreview';

interface DonationPreviewProps {
  contentsMarkup: string;
}

export default function DonationPreview({
  contentsMarkup,
}: DonationPreviewProps) {
  return (
    <div className="w-[400px] flex-shrink-0">
      <PhonePreview>
        <div className="sticky top-0 z-10">
          <img
            src="/assets/images/img-app-header-preview.png"
            alt="img-notice-header-preview"
            width="100%"
            height="auto"
          />
          <p
            className="absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]"
            style={{
              fontFamily: 'Pretendard',
              fontSize: '18px',
              fontWeight: 700,
              lineHeight: '28px',
            }}
          >
            기부하기 상세
          </p>
        </div>
        <PhonePreview.Content className="p-0">
          <div
            className="ck-content"
            dangerouslySetInnerHTML={{
              __html: contentsMarkup,
            }}
          />
        </PhonePreview.Content>
      </PhonePreview>
    </div>
  );
}
